import {FeatureConfig} from '@/utils/constants/featuresFlag';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {API_VERSION, Constants} from '@/utils/constants/commonConstants';
import {buildQueryParams} from '@/utils/commons';
import {logger} from '@/helpers/logger';

// Defense-in-depth: reject path traversal patterns
export const containsPathTraversal = (str) =>
  typeof str === 'string' && str.includes('..');

export const shouldUseMock = (config) => {
  return config.mockData || config.mockPath;
};

export const loadMockFromPath = async (mockPath) => {
  try {
    const response = await fetch(mockPath);
    if (!response.ok) {
      throw new Error(`Failed to fetch mock: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    logger.warn(
      `[apiClient] Failed to load mock from ${mockPath}:`,
      error.message
    );
    return {};
  }
};

export const getMockResponse = async (config) => {
  if (config.mockData) {
    return config.mockData;
  }

  if (config.mockPath) {
    return await loadMockFromPath(config.mockPath);
  }

  return {};
};

export const shouldAppendQueryParams = (config, queryParams) => {
  if (!queryParams) return false;

  const method = config.method || HTTP_METHODS.GET;
  const isGet = method === HTTP_METHODS.GET;
  const isMultipartPost =
    method === HTTP_METHODS.POST && config.multipart === Constants.Multipart;

  return isGet || isMultipartPost || config.appendQueryParams;
};

export const buildEndpoint = (config, queryParams) => {
  let endpoint = '';

  // Block path traversal attempts in endpoint or query params
  if (
    containsPathTraversal(config.endPoint) ||
    containsPathTraversal(queryParams)
  ) {
    logger.error('Blocked potential path traversal attempt');
    return '';
  }

  if (config.growthbookSdkKey) {
    const sdkValue = import.meta.env[FeatureConfig[config.growthbookSdkKey]];
    endpoint = `/${config.endPoint}/${sdkValue}`;
  } else if (config.baseUrlKey) {
    endpoint = `/${config.endPoint}`;
  } else {
    const version = config.version || API_VERSION.V1;
    endpoint = `${version}/${config.endPoint}`;
  }

  if (shouldAppendQueryParams(config, queryParams)) {
    const queryString = buildQueryParams(queryParams);
    endpoint += `?${queryString}`;
  }

  return endpoint;
};

export const buildRequestOptions = (config, options, endpoint) => ({
  method: config.method || HTTP_METHODS.GET,
  url: endpoint,
  headers: {
    'Content-Type': config.contentType || 'application/json',
    ...config.headers
  },
  ...options
});
